import { Box, Typography } from "@mui/material";
import ActiveLocationsTable from "./table";
import { useGetLocationsList } from "src/api/locations";

const ArchivedLocationsPage = () => {
  // APIS
  const { data, isFetching, refetch } = useGetLocationsList({
    type: "archived",
  });

  return (
    <Box p={"30px"} data-testid="archived-locations-page">
      <Typography
        mb={4}
        fontSize={"22px"}
        fontWeight={600}
        data-testid="archived-locations-title"
      >
        Archived Locations
      </Typography>
      <ActiveLocationsTable
        rowsList={data?.locations || []}
        citiesList={data?.cities || []}
        services={data?.services || []}
        clients={data?.clients || []}
        isLoading={isFetching}
        refetch={refetch}
      />
    </Box>
  );
};

export default ArchivedLocationsPage;
